import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {stats, getBucketByAccuracy} from 'lib/StatsUtil';
import './performance-indicator.scss';

export default class PerformanceIndicator extends React.PureComponent {
  static propTypes = {
    isUnavailable: PropTypes.bool,
    numberCorrect: PropTypes.number,
    total: PropTypes.number,
    small: PropTypes.bool,
    gtgTag: PropTypes.string // data-gtg tag for grades transferer extension
  };

  render() {
    const {numberCorrect, total, gtgTag} = this.props;
    const accuracy = stats.percentage(numberCorrect, total);
    const masteryBucket = getBucketByAccuracy(accuracy);
    const displayName = masteryBucket.DISPLAY_NAME;
    const displayNameEl = (
      <div className='performance-indicator__display-name'>
        {this.props.isUnavailable ? 'Not Available' : displayName}
      </div>
    );
    const accuracyEl = this.props.isUnavailable ? null : (
      <div className='performance-indicator__accuracy'>{accuracy}%</div>
    );
    return (
      <div
        className={classnames('performance-indicator', {
          [`performance-indicator--${displayName.toLowerCase()}`]: !this.props.isUnavailable,
          'performance-indicator--small': this.props.small
        })}
      >
        {displayNameEl}
        {accuracyEl}
        <span data-gtg={gtgTag} className='u-display_none' aria-hidden='true'>
          {numberCorrect}
        </span>
      </div>
    );
  }
}
